import { type AnyObject, createPluginFactory } from '@udecode/plate'
import type { BufferValue } from '~publish/legacy/editor/BufferEditor/types.plate'
import { withTextSanitization } from './withTextSanitization'

export const TEXT_SANITIZATION_PLUGIN_KEY = 'text-sanitization-plugin'

export const createTextSanitizationPlugin = createPluginFactory<
  AnyObject,
  BufferValue
>({
  key: TEXT_SANITIZATION_PLUGIN_KEY,
  withOverrides: withTextSanitization,
})
